// extracted by mini-css-extract-plugin
export var orderSummary = "_m0-0";
export var showMoreLessButton = "_m0-1";